<template>
  <div class="h-100">
    <Navbar/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/NavbarComponent.vue'
export default {
  name: 'DashboardView',
  components: {
    Navbar
  },
  data: () => ({}),
  created() {},
  methods : {}
}
</script>

<style>
</style>